import { ArpMedia } from '@arpeggi/shared'
import { IArpMedia } from '../../features/arp-registry/ArpMedia'

export const detailPageUrl = (media: ArpMedia | IArpMedia) => {
  return `/${media.type}?token=${media.id}`
}
